












































































































import BaseComponent from "@/asdcom/BaseComponent"
import { Component, Vue, Inject } from "vue-property-decorator";
import util from "@/lib/util";
import { AbpApiResponse } from "src/store/models/common";
import { ButtonList } from "sweetalert/typings/modules/options/buttons";
import { Asdcom } from "@/asdcom/appservice.asdcom";
import { AuthenticateModel } from "../../../asdcom/apiproxy/apiproxy.dto";

@Component({})
export default class Login extends BaseComponent {
  accountService = new Asdcom.AccountAppService();
  loginModel: AuthenticateModel = new AuthenticateModel();

  public createAccount(): void {
    this.$router.push({ name: "CreateAccount" });
  }

  async login() {
    this.ValidateAll().then(async (isValid: boolean) => {
      if (isValid) {
        let tokenService = new Asdcom.TokenAuthAppService();
        const loginRes = await tokenService.loginStaff(this.loginModel);

        // await this.$store
        //   .dispatch({
        //     type: "asdcom/app/login",
        //     data: this.loginModel
        //   })
        //   .catch((response: AbpApiResponse) => {
        //     //abp.log.debug({ "Login error": response });

        //     const err = response.error;
        //     // if we have an error, handle it here.
        //     if (err !== undefined) {
        //       const errorCode = !!response.error ? response.error.code : 0;
        //       // const details = JSON.parse(err.details || "");
        //       //const userId = details ? details.userId : undefined;
        //       const username = this.$store.state.session.userName;

        //       // if error is unverified email
        //       if (
        //         errorCode ==
        //           util.abp.constant.apiErrorCodesEnum.unverifiedEmail &&
        //         username !== undefined
        //       ) {
        if (loginRes.emailIsNotVerified) {
          const msgEl = document.createElement("div");
          msgEl.innerHTML = this.L(
            "UserEmailIsNotConfirmedAndCanNotLogin",
            undefined,
            this.L("ResendVerificationEmail")
          );
          sweetAlert({
            title: this.L("EmailVerificationPending"),
            content: { element: msgEl },
            icon: "warning",
            buttons: {
              submit: {
                text: this.L("ResendVerificationEmail"),
                value: true,
                closeModal: false
              },
              cancel: this.L("Close")
            } as ButtonList
          }).then((isResend: boolean) => {
            if (isResend) {
              msgEl.innerHTML = this.L("ReSendEmailVerificationLinkMessage");

              // this.$store
              //   .dispatch(
              //     "asdcom/account/sendEmailActivationLink",
              //     username
              //   )
              this.accountService.resendEmailActivationLink(loginRes.username)
                .then(() => {
                  this.loginModel = new AuthenticateModel();
                  this.$nextTick(() => {
                    this.$validator.reset();
                  });
                  sweetAlert({
                    title: this.L("Success"),
                    content: { element: msgEl },
                    icon: "success"
                  });
                });
            }
          });
        }

        //     }
        //   });

        sessionStorage.setItem(
          "rememberMe",
          this.loginModel.rememberClient ? "1" : "0"
        );
      } else {
        // sweetAlert({ title: this.L("UnknownError"), icon: "error" });
      }
    });
  }
}
